module.exports = __webpack_public_path__ + "static/media/AddProject.f60b061b.svg";